/* unplugin-vue-components disabled */import script from "./FragmentUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FragmentUpload.vue?vue&type=script&setup=true&lang=ts"

import "./FragmentUpload.vue?vue&type=style&index=0&id=5c2207d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2207d9"]])

export default __exports__